<template>
  <el-dialog class="align-center" :visible.sync="visible">
    <el-form>
      <el-alert
        type="warning"
        title="Your Git server will be hosted locally"
        description="if the cloud server is terminated, all repositories data will be lost"
        center
        :closable="false"
      />

      <el-form-item :error="error">
        <el-input v-model="value" placeholder="Give your Repository an identifying name" />
      </el-form-item>

      <p v-if="name.length > 0">
        git@{{ instance.hostname }}:<strong>{{ name }}</strong>
      </p>
    </el-form>

    <el-button
      type="primary"
      :loading="loading"
      :disabled="name.length === 0"
      @click="create"
    >
      Create a new Git repository
    </el-button>
  </el-dialog>
</template>

<script>
export default {
  props: {
    instance: Object,
    applicationId: {
      type: String,
      default: null
    },
    open: Boolean
  },
  data () {
    return {
      visible: this.open,
      error: null,
      value: '',
      loading: false
    }
  },
  computed: {
    name () {
      return this.value.toLowerCase().trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]+/g, '')
    }
  },
  methods: {
    create () {
      this.loading = true
      this.$store.dispatch('createRepository', {
        instanceId: this.instance.id,
        name: this.name
      }).then((repository) => {
        this.visible = false

        if (this.applicationId) {
          this.$store.dispatch('connectRepository', {
            id: repository.id,
            applicationId: this.applicationId
          }).then(() => this.$emit('change'))
        } else {
          this.$emit('change')
        }
      }).catch(() => {
        this.loading = false
        this.error = 'This repository name already exists'
      })
    }
  },
  watch: {
    open (value) {
      this.error = null
      this.loading = false
      this.visible = value
    },
    visible (value) {
      this.$nextTick(() => this.$emit('update:open', value))
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-alert {
    margin-bottom: 20px;
  }
  .el-form {
    p {
      background-color: $--background-color-base;
      padding: 9px 4px;
      font-size: 13px;
    }
  }
</style>
